// src/hooks/usePagination.js
import { useState, useMemo } from "react";

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export function usePagination(items, defaultPageSize = 25) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);

  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));

  // Reset to page 1 when items or pageSize change
  const safePage = Math.min(page, totalPages);

  const paginated = useMemo(() => {
    const start = (safePage - 1) * pageSize;
    return items.slice(start, start + pageSize);
  }, [items, safePage, pageSize]);

  const goTo = (p) => setPage(Math.max(1, Math.min(p, totalPages)));

  const changePageSize = (size) => {
    setPageSize(size);
    setPage(1);
  };

  return {
    paginated,
    page: safePage,
    pageSize,
    totalPages,
    totalItems: items.length,
    goTo,
    changePageSize,
  };
}
